import React, { useEffect, useState } from "react";
import { Tab, Nav, Alert } from "react-bootstrap";
import axios from "axios";
import { NODE_API_URL, BASE_URL } from "../../../env_config";
import Cookies from "js-cookie";
import { SupplierManagement } from "../DiamondFeedNew/SupplierManagement";
import ShopifyAppTaxSetting from "./ShopifyAppTaxSetting";
import ShopifyAppThemeSetting from "./ShopifyAppThemeSetting";
import ShopifyAppParameterPermissions from "./ShopifyAppParameterPermissions";
import { Chip, makeStyles, useMediaQuery, useTheme } from "@material-ui/core";
import ShopifyAppSettingAuth from "./ShopifyAppSettingAuth";
import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
    cardBody: {
        [theme.breakpoints.up("xs")]: {
            padding: `0px !important`,
        },
        [theme.breakpoints.up("sm")]: {
            padding: `${0.25 * 10}rem !important`,
        },
    },
}));

const ShopifyAppSetting = ({ language, conversionrate, symbol, userinfo }) => {
    const classes = useStyles();
    const theme = useTheme();
    const isMd = useMediaQuery(theme.breakpoints.down("md"));

    const history = useHistory();

    const [key, setKey] = useState("setting");

    const [feedsetting, setFeedSetting] = useState(null);
    const [feedsettingReload, setFeedSettingReload] = useState(0);

    useEffect(() => {
        const source = axios.CancelToken.source();

        axios({
            method: "get",
            url: `${NODE_API_URL}/INTL/fetch-iframeorapi`,
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${Cookies.get("cust_auth_token")}`,
            },
            cancelToken: source.token,
        })
            .then((res) => {
                if (res && res.data && res.data.data) {
                    setFeedSetting(res.data.data);
                }
            })
            .catch((error) => {
                if (error?.response?.data?.message === "UnAuthorized!") {
                    var cookies = document.cookie.split(";");
                    for (var i = 0; i < cookies.length; i++) {
                        if (cookies[i] && !cookies[i].includes("view")) {
                            var equals = cookies[i].indexOf("=");
                            var name =
                                equals > -1
                                    ? cookies[i].substr(0, equals)
                                    : cookies[i];
                            document.cookie =
                                name +
                                "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
                        }
                    }

                    window.location.replace(`${BASE_URL}/logout`);
                }
            });

        return () => {
            source.cancel("Component unmounted: cancel pending request");
        };
    }, [feedsettingReload]);

    return (
        <>
            {feedsetting &&
            feedsetting.api === 1 &&
            (feedsetting.feed_type === "SHOPIFY APP" || feedsetting.feed_type === "SHOPIFY APP RING") ? (
                <div className="container-fluid feed-theme">
                    {feedsetting.api_live_mode === 0 &&
                    feedsetting.api_test_mode !== "ON" ? (
                          <Alert variant="warning">
                            Your Shopify app is currently in
                            testing. To start testing activate test mode. To
                            activate Live Mode, please contact your account
                            executive.
                        </Alert>
                    ) : (
                        ""
                    )}
                    {feedsetting.api_live_mode === 0 &&
                    feedsetting.api_test_mode === "ON" ? (
                        <Alert variant="warning">
                            To activate Live Mode, please contact
                            your account executive.
                        </Alert>
                    ) : (
                        ""
                    )}
                    <Tab.Container
                        id="settingTab"
                        activeKey={key}
                        onSelect={(k) => setKey(k)}
                    >
                        <div className="row">
                            <div
                                className={`${
                                    isMd ? "col-12" : "col-3"
                                } card custom-card border-0 rounded-0`}
                            >
                                <div>
                                    <Nav
                                        variant="pills"
                                        className="flex-column custom_nav"
                                    >
                                        <Nav.Item>
                                            <Nav.Link
                                                className="flex-wrap"
                                                onClick={() =>
                                                    history.push({
                                                        pathname:
                                                            "/diamondfeed",
                                                    })
                                                }
                                            >
                                                <span className="font-size-h5 px-0 col-12">
                                                    Shopify Dashboard
                                                </span>
                                                <span className="text-muted small px-0 col-12">
                                                    Back to rule page
                                                </span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className="flex-wrap"
                                                eventKey="setting"
                                            >
                                                <span className="font-size-h5 px-0 col-12">
                                                    Shopify App Settings
                                                </span>
                                                <span className="text-muted small px-0 col-12">
                                                    Shopify App Settings
                                                </span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className="flex-wrap"
                                                eventKey="theme"
                                            >
                                                <span className="font-size-h5 px-0 col-12">
                                                    Shopify App Theme
                                                </span>
                                                <span className="text-muted small px-0 col-12">
                                                    Shopify App theme setting
                                                </span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className="flex-wrap"
                                                eventKey="tax"
                                            >
                                                <span className="font-size-h5 px-0 col-12">
                                                    Shopify App Currency & Tax
                                                </span>
                                                <span className="text-muted small px-0 col-12">
                                                    Shopify App Currency & Tax
                                                    setting
                                                </span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className="flex-wrap"
                                                eventKey="parameterpermissions"
                                            >
                                                <span className="font-size-h5 px-0 col-12">
                                                    Shopify App Parameter
                                                    Permissions
                                                </span>
                                                <span className="text-muted small px-0 col-12">
                                                    Shopify App parameter
                                                    Permissions
                                                </span>
                                            </Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link
                                                className="flex-wrap"
                                                eventKey="suppliermanagement"
                                            >
                                                <span className="font-size-h5 px-0 col-12">
                                                    Supplier Management
                                                </span>
                                                <span className="text-muted small px-0 col-12">
                                                    Manage Suppliers
                                                </span>
                                            </Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </div>
                            </div>
                            <div
                                className={`${
                                    isMd ? "col-12" : "col-9"
                                } card bg-white custom-card custom-scrollbar`}
                                style={{ maxHeight: "85vh" }}
                            >
                                <div
                                    className={`card-body ${classes.cardBody}`}
                                    id="themesetting"
                                >
                                    <Tab.Content>
                                        <Tab.Pane eventKey="setting">
                                            <ShopifyAppSettingAuth
                                                userinfo={userinfo}
                                                language={language}
                                                feedsetting={feedsetting}
                                                setFeedSettingReload={
                                                    setFeedSettingReload
                                                }
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="theme">
                                            <ShopifyAppThemeSetting
                                                userinfo={userinfo}
                                                language={language}
                                                feedsetting={feedsetting}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="tax">
                                            <ShopifyAppTaxSetting
                                                userinfo={userinfo}
                                                language={language}
                                                feedsetting={feedsetting}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="parameterpermissions">
                                            <ShopifyAppParameterPermissions
                                                userinfo={userinfo}
                                                language={language}
                                                feedsetting={feedsetting}
                                            />
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="suppliermanagement">
                                            <SupplierManagement
                                                language={language}
                                                conversionrate={conversionrate}
                                                symbol={symbol}
                                                userinfo={userinfo}
                                                feedsetting={feedsetting}
                                            />
                                        </Tab.Pane>
                                    </Tab.Content>
                                </div>
                            </div>
                        </div>
                    </Tab.Container>
                </div>
            ) : (
                ""
            )}
        </>
    );
};

export default ShopifyAppSetting;
